import { t } from '../i18n.js';

export function createErrorSection(errorMessage) {
  const errorSection = document.createElement('div');
  errorSection.className = 'error-section';
  
  errorSection.innerHTML = `
    <div class="error-header">
      <span class="error-icon">⚠</span>
      <h4>${t('error')}</h4>
    </div>
    <p>${errorMessage}</p>
    <button onclick="window.location.reload()" class="secondary-button">${t('retry')}</button>
  `;
  
  return errorSection;
} 